module.exports = __webpack_public_path__ + "static/media/kid_avatar_06.e045838c.png";